// removed by extract-text-webpack-plugin
module.exports = {"cookiePolicy":"_2O1b8","cookiePolicyText":"_3cGun","cookiePolicyLink":"_37G6i"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AcceptCookies/index.sass
// module id = 1452
// module chunks = 1